import './style/dashboard.css';
import { createApp } from './core/app.js';
import { addLogoutButton, ensureAuthenticated, getAuthContext } from './auth/cognito.js';

async function bootstrap() {
  await ensureAuthenticated();
  const auth = getAuthContext();

  createApp({
    rootEl: document.getElementById('app'),
    mapEl: document.getElementById('map'),
    leftPanelEl: document.getElementById('left-panel'),
    rightPanelEl: document.getElementById('right-panel'),
    bottomPanelEl: document.getElementById('bottom-panel'),
    topbarEl: document.getElementById('topbar'),
    hudEl: document.getElementById('hud'),
    auth,
  });

  addLogoutButton();
}

bootstrap().catch((error) => {
  console.error('HydroTools auth bootstrap failed:', error);
  document.body.innerHTML =
    `<pre style="padding:16px;color:#fff;background:#5f1d1d;">` +
    `Authentication initialization failed.\n${String(error?.message || error)}` +
    `</pre>`;
});
